__turbopack_context__.v({
  "container": "index-module-scss-module__qaidtG__container",
  "features": "index-module-scss-module__qaidtG__features",
  "horizontal-image": "index-module-scss-module__qaidtG__horizontal-image",
  "list": "index-module-scss-module__qaidtG__list",
  "modal-button": "index-module-scss-module__qaidtG__modal-button",
  "modal-button-base": "index-module-scss-module__qaidtG__modal-button-base",
  "modal-container": "index-module-scss-module__qaidtG__modal-container",
  "modal-header": "index-module-scss-module__qaidtG__modal-header",
  "modal-subtitle": "index-module-scss-module__qaidtG__modal-subtitle",
  "modal-title": "index-module-scss-module__qaidtG__modal-title",
  "title": "index-module-scss-module__qaidtG__title",
  "vertical-image": "index-module-scss-module__qaidtG__vertical-image",
});
